enum StepDisplayConfigButtonType {
  Link = "Link",
  CopyToClipboard = "CopyToClipboard",
}

export { StepDisplayConfigButtonType };
